<template>
  <!-- eslint-disable max-len -->
  <div class="bpc-documents">
    <bpc-page-top :breadcrumb=breadcrumb :links=links></bpc-page-top>
    <bpc-page-title :heading=heading :subheading=subheading :avatar=avatar :icon=icon :actions="actions" :selection=selection>
      <b-button  class="ml-2" v-b-modal.modal-create-document variant="success">
        <font-awesome-icon class="mr-2" icon="plus"/>Create New</b-button>
    </bpc-page-title>
    <b-card _title="Example" class="main-card mb-4">
      <bpc-table :items=items :fields=fields :selection=selection :filters=filters @update-selection="updateSelection"></bpc-table>
    </b-card>
    <b-modal id="modal-create-document" size="lg" title="Create document">
      <bpc-form-create-document></bpc-form-create-document>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="show=false">Cancel</b-button>
        <b-dropdown variant="primary" @click="show=false" right split text="Save">
          <b-dropdown-item @click="show=false">Save & Edit</b-dropdown-item>
          <b-dropdown-item>Save & New</b-dropdown-item>
        </b-dropdown>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import BpcPageTop from '@/mockups/layouts/components/BpcPageTop.vue';
import BpcPageTitle from '@/mockups/layouts/components/BpcPageTitle.vue';
import BpcTable from '@/mockups/tables/BpcTable.vue';
import BpcFormCreateDocument from '@/mockups/forms/BpcFormCreateDocument.vue';

library.add(
  faPlus,
);

import avatar1 from '../../assets/avatars/1.jpg';
import avatar2 from '../../assets/avatars/2.jpg';
import avatar3 from '../../assets/avatars/3.jpg';
import avatar4 from '../../assets/avatars/4.jpg';
import avatar5 from '../../assets/avatars/5.jpg';
import avatar6 from '../../assets/avatars/6.jpg';
import avatar7 from '../../assets/avatars/7.jpg';
import avatar8 from '../../assets/avatars/8.jpg';
import avatar9 from '../../assets/avatars/9.jpg';
import avatar10 from '../../assets/avatars/10.jpg';

const items = [
  {
    id: 1,
    checked: false,
    date: '2020-03-01',
    name: 'Contrat Speedy MSG',
    type: 'Contrat',
    format: '',
    status: 'active',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar1,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
      {
        id: 2,
        checked: false,
        code: '023567',
        birthdate: { date: '1998-10-15', age: 21 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Larsen', last: 'Shaw' },
        img_url: avatar2,
        contact_details: {
          phone: '04/56.78.90',
          phone2: '',
          email: 'larsen.shaw@test.com',
          email2: 'demo@admin.be',
        },
      },
    ],
  },
  {
    id: 2,
    checked: false,
    date: '2020-02-21',
    name: 'Convention membre',
    type: 'Convention',
    format: 'pdf',
    status: 'active',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar1,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
    ],
  },
  {
    id: 3,
    checked: false,
    date: '2020-02-21',
    name: 'Rapport mensuel',
    type: 'Rapport',
    format: 'excel',
    status: 'active',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar3,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
      {
        id: 2,
        checked: false,
        code: '023567',
        birthdate: { date: '1998-10-15', age: 21 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Larsen', last: 'Shaw' },
        img_url: avatar4,
        contact_details: {
          phone: '04/56.78.90',
          phone2: '',
          email: 'larsen.shaw@test.com',
          email2: 'demo@admin.be',
        },
      },
      {
        id: 2,
        checked: false,
        code: '023567',
        birthdate: { date: '1998-10-15', age: 21 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Larsen', last: 'Shaw' },
        img_url: avatar5,
        contact_details: {
          phone: '04/56.78.90',
          phone2: '',
          email: 'larsen.shaw@test.com',
          email2: 'demo@admin.be',
        },
      },
      {
        id: 2,
        checked: false,
        code: '023567',
        birthdate: { date: '1998-10-15', age: 21 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Larsen', last: 'Shaw' },
        img_url: avatar6,
        contact_details: {
          phone: '04/56.78.90',
          phone2: '',
          email: 'larsen.shaw@test.com',
          email2: 'demo@admin.be',
        },
      },
    ],
  },
  {
    id: 3,
    checked: false,
    date: '2020-02-21',
    name: 'Facture n°12345',
    type: 'Facture',
    format: 'pdf',
    status: 'active',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar7,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
    ],
  },
  {
    id: 3,
    checked: false,
    date: '2020-02-21',
    name: 'Rapport d\'activité',
    type: 'Rapport',
    format: 'chart',
    status: 'active',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar7,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
    ],
  },
];

const fields = [
  // 'index',
  // {
  //   key: 'color', label: '', class: 'color',
  // },
  {
    key: 'checked', label: 'Check', class: 'check',
  },
  {
    key: 'format', label: 'Format', class: 'format',
  },
  // {
  //   key: 'code', label: '# Ref', class: 'code', sortable: true, sortDirection: 'desc',
  // },
  {
    key: 'name', label: 'Document name', class: 'name', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'type', label: 'Type', class: 'type', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'date', label: 'Creation date', class: 'date', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'contacts', label: 'Contacts', class: 'contacts relations', sortable: true, sortDirection: 'desc',
  },
  // {
  //   key: 'status', label: 'Status', class: 'status', sortable: true, sortDirection: 'desc',
  // },
  {
    key: 'actions', label: 'Actions', class: 'actions',
  },
];

const filters = {
  'search': true, 
  'status': true, 
  'document_type': true, 
  'document_tags': true,
  'more': true,
};

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    BpcPageTop,
    BpcPageTitle,
    BpcTable,
    BpcFormCreateDocument,
  },
  data: () => ({
    heading: 'Documents',
    subheading: 'Here are all your documents : contacts, conventions, factures, etc',
    icon: '', // 'pe-7s-users icon-gradient bg-tempting-azure',
    avatar: '',
    breadcrumb: ['Dashboard', 'Documents'],
    links: ['Help', 'Settings'],
    actions: {
      delete: true, bulk: true, new: false, edit: false, actions: true,
    },
    items,
    fields,
    selection: [],
    filters,
  }),
  methods: {
    updateSelection(selection) {
      this.selection = selection;
    },
  },
};
</script>

<style>
.card-body {
  padding: 0 !important;
}
.card-title {
  padding: 1.25rem 0.825rem 0.5rem;
}
</style>
